import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    sendAgain: 'Send again',
    sending: `Sending can take few seconds...`,
    sentTo: 'The link to download the application has been sent to',
    thankYou: 'Thank you! A link was sent to you by SMS',
  },
  fr: {
    sendAgain: 'Envoyer de nouveau',
    sending: 'L’envoi peut prendre quelques secondes...',
    sentTo: 'Le lien pour télécharger l’application a été envoyé au',
    thankYou: 'Merci\u00A0! Un lien vous a été envoyé par SMS',
  },
} as const);
